import { Link } from 'react-router-dom';

export default function HeroSection() {
  const heroImage = 'https://readdy.ai/api/search-image?query=Minimalist%20abstract%20geometric%20composition%20with%20warm%20cream%20and%20soft%20golden%20accents%2C%20flowing%20organic%20shapes%2C%20elegant%20gradient%20background%20with%20subtle%20texture%2C%20modern%20luxurious%20atmosphere%2C%20soft%20diffused%20lighting%2C%20high%20end%20brand%20visual%20identity&width=1800&height=1000&seq=baoyu-hero-bg&orientation=landscape';

  return (
    <section className="relative w-full h-screen min-h-[600px] flex items-center justify-center overflow-hidden">
      <img
        src={heroImage}
        alt="baoyu 品牌形象 - 创新科技与卓越品质"
        title="baoyu 品牌形象"
        className="absolute inset-0 w-full h-full object-cover object-top"
      />
      <div className="absolute inset-0 bg-gradient-to-b from-black/40 via-black/25 to-black/50"></div>

      <div className="relative z-10 w-full max-w-7xl mx-auto px-4 md:px-6 text-center">
        <p className="text-white/70 text-sm md:text-base tracking-widest uppercase mb-4 animate-[fadeInUp_0.6s_ease-out]">
          探索未来的无限可能
        </p>
        <h1 className="text-3xl sm:text-4xl md:text-6xl lg:text-7xl font-bold text-white mb-6 animate-[fadeInUp_0.6s_ease-out_0.1s]">
          baoyu
          <span className="block text-xl sm:text-2xl md:text-3xl font-normal mt-2 text-white/80">
            以创新科技，定义非凡体验
          </span>
        </h1>
        <p className="text-white/60 text-sm md:text-lg max-w-2xl mx-auto mb-10 leading-relaxed animate-[fadeInUp_0.6s_ease-out_0.2s]">
          baoyu 致力于为全球用户提供卓越品质的产品与服务。从旗舰系列到青春系列，
          每一款 baoyu 产品都承载着我们对创新与品质的不懈追求。
        </p>
        <div className="flex flex-col sm:flex-row items-center justify-center gap-4 animate-[fadeInUp_0.6s_ease-out_0.3s]">
          <Link
            to="/category/all"
            className="px-8 py-3.5 rounded-full bg-primary-500 text-background-50 text-sm font-semibold transition-all duration-200 whitespace-nowrap hover:bg-primary-600 cursor-pointer"
          >
            探索全部产品
          </Link>
          <Link
            to="/about"
            className="px-8 py-3.5 rounded-full border border-white/30 text-white text-sm font-semibold transition-all duration-200 whitespace-nowrap hover:bg-white/10 cursor-pointer"
          >
            了解 baoyu
          </Link>
        </div>
      </div>
    </section>
  );
}